import { createStore } from '@servicetitan/financing-utils-shared';
import { useState, useEffect } from 'react';

interface CustomPlansState {
    customPlanIds: string[];
    provider?: string;
}

function useCustomPlans(initialState: CustomPlansState = { customPlanIds: [] }) {
    const [state, setState] = useState<CustomPlansState>(initialState);

    useEffect(() => {
        // Read plan IDs and provider from URL query parameters
        const urlParams = new URLSearchParams(window.location.search);
        const planIds = urlParams.getAll('plan');
        const provider = urlParams.get('provider') ?? undefined;

        // Only override initialState when URL params are present
        if (planIds.length > 0 || provider) {
            setState({
                customPlanIds: planIds,
                provider,
            });
        }
    }, []);

    const setCustomPlanIds = (planIds: string[]) => {
        setState(prev => ({ ...prev, customPlanIds: planIds }));
    };

    const setProvider = (provider: string | undefined) => {
        setState(prev => ({ ...prev, provider }));
    };

    return {
        customPlanIds: state.customPlanIds,
        provider: state.provider,
        setCustomPlanIds,
        setProvider,
        hasCustomPlans: state.customPlanIds.length > 0,
    };
}

export const CustomPlansStore = createStore(useCustomPlans);
export type CustomPlansStoreValue = ReturnType<typeof useCustomPlans>;
